import React from 'react';
import { Link } from 'react-router-dom';

const LEAD_CONTEXT_KEY = 'lead_context_v1';

const Services = () => {
    const setLeadContext = (ctx) => {
        try { window.localStorage.setItem(LEAD_CONTEXT_KEY, JSON.stringify(ctx)); } catch { /* no-op */ }
    };

    const servicesList = [
        {
            id: 'strategy',
            icon: 'fas fa-chess',
            title: 'AI Strategy & Consulting',
            desc: 'Prioritized roadmaps, investment cases, operating models, and governance plans that executives can defend.'
        },
        {
            id: 'ml',
            icon: 'fas fa-brain',
            title: 'Machine Learning Solutions',
            desc: 'Production-ready predictive, NLP, and computer vision systems designed around your data quality and business controls.'
        },
        {
            id: 'automation',
            icon: 'fas fa-robot',
            title: 'Automation & Optimization',
            desc: 'Intelligent workflows that remove manual load, reduce operational risk, and keep human approval where it matters.'
        },
        {
            id: 'analytics',
            icon: 'fas fa-chart-pie',
            title: 'Data Analytics',
            desc: 'Decision-grade dashboards, forecasting, and data products that make performance visible across teams.'
        },
        {
            id: 'integration',
            icon: 'fas fa-network-wired',
            title: 'Custom AI Integration',
            desc: 'Secure integration with existing systems, cloud platforms, and operational workflows without unnecessary rebuilds.'
        },
        {
            id: 'training',
            icon: 'fas fa-chalkboard-teacher',
            title: 'AI Training & Workshops',
            desc: 'Role-specific enablement for leadership, product, operations, and technical teams adopting AI responsibly.'
        }
    ];

    return (
        <section id="services" className="services-section">
            <div className="container">
                <div className="section-header fade-in">
                    <p className="eyebrow">What We Build</p>
                    <h2>AI programs that move from boardroom intent to production value.</h2>
                    <p>Each engagement is scoped around measurable outcomes, governance, and operational adoption.</p>
                </div>

                <div className="services-grid">
                    {servicesList.map((service) => (
                        <div key={service.id} className="service-card fade-in">
                            <div className="service-icon">
                                <i className={service.icon} aria-hidden="true"></i>
                            </div>
                            <h3>{service.title}</h3>
                            <p>{service.desc}</p>
                            <Link
                                className="service-link"
                                to="/contact"
                                onClick={() => setLeadContext({ service: service.id, message: `Interested in ${service.title}.` })}
                            >
                                Discuss this service <i className="fas fa-arrow-right" aria-hidden="true"></i>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
